module.exports = __webpack_public_path__ + "img/icon-calendar.bd2c08b7.svg";